<template>
    <div class="wrap" v-if="showConfirmBtn">
        <span class="question-bg"></span>
        <car-headerbar v-if="isGuaGua && !isHideHeader" :title="question.pageName" />
        <div
            class="question-tip"
            v-if="isAnonymous && isRunning && footer==='eim'">
            此问卷为匿名问卷，系统不会获取任何用户身份信息。
        </div>
        <div class="content" v-if="isRunning" :class="{addPadding}">
            <div
                class="question-header"
                :class="{'question-line': question.pageComment}">
                <div class="title">{{question.pageName}}</div>
                <div v-if="$route.query.type !== 'approve'">
                    <img
                        src="../images/icon-copy.png"
                        class="question-copy-url"
                        v-if="isAnonymous && footer==='eim'"
                        @click="copyUrl">
                    <span
                        v-if="isAnonymous && footer==='eim'"
                        class="question-pc-copy-url"
                        @click="copyUrl">
                        <img
                            src="../images/icon-copy.png"
                            @click="copyUrl"
                            alt="复制问卷链接"
                            class="copy-img">
                        <span class="copy-text">复制问卷链接</span>
                    </span>
                    <img :src="qrCodeUrl" class="question-qr-code">
                </div>
                <div v-if="!isInIframe">
                    <me-field
                        class="comment"
                        v-if="question.pageComment"
                        v-model="question.pageComment"
                        autosize
                        rows="1"
                        label=""
                        type="textarea"
                        disabled
                    />
                </div>
                <div v-else>
                    <pre
                        class="comment"
                        v-if="question.pageComment"
                        v-html="question.pageComment"></pre>
                </div>

                <div
                    class="question-pc-tip"
                    v-if="isAnonymous && footer==='eim'">
                    此问卷为匿名问卷，系统不会获取任何用户身份信息。
                </div>
            </div>
            <img :src="logos[footer]" class="copyright">
            <CarsForm
                class="form"
                ref="dcDynamicForm"
                :configData="configData"
                :model="model"
                @submitError="submitError"
                v-on:[eventName]="eventHandler"
                @addEventListenerForInput="addEventListenerForInput"
                @removeEventListenerForInput="removeEventListenerForInput"
            />
        </div>
        <div class="msg-tips" v-else>
            <div class="tips-wrap">
                <span class="c-bg"></span>
                <span class="c-text">{{msgTips}}</span>
            </div>
            <div class="b-bg">
                <img class="b-app" src="../images/b-app.png">
                <span class="b-pc"></span>
                <span
                    class="create-ques"
                    @click="$router.push('/mine')"
                    v-if="isGuaGua && !isAnonymous && $route.query.type !== 'approve'">我也要创建问卷</span>
            </div>
        </div>
    </div>
</template>

<script>
import CarsForm from 'imc-mobile/src/component/form'
import copy from '@/util/copy'
import { Questionnaire } from '@/network'
import { ENV } from '@/network/instance/generator'
import { baseUrls } from '@/network/config/service-baseurl'
import { mixin } from '@/mixins'
// import { Toast } from '@guazi-fe/melon'
import { getScrollTop } from '@/util/dom-util'
// import { off as offStatus } from '@/util/status-util'
import { addClass2, removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import { Toast } from '@guazi-fe/melon'
const eim = require('../images/copyright.png')
const chehaoduo = require('../images/chehaoduo.png')
import { getStorage, setStorage } from '@/util/common'
import { setMessenger } from 'handle-approval-message-js-sdk'
import { userInfoReady } from '../../../network/instance/interceptors'

export default {
    name: 'question',
    data() {
        return {
            eventName: 'submitAction',
            eventHandler: this.submitSuccess,
            question: {},
            topicsList: [],
            model: {},
            BASEURL: baseUrls.plat[ENV], // network 拿到的环境变量
            msgTips: '',
            isRunning: true,
            isAnonymous: false,
            showConfirmBtn: false,
            shareUrl: '',
            qrCodeUrl: '',
            isGuaGua: false,
            logos: { eim, chehaoduo },
            footer: 'eim',
            openTime: new Date().getTime(),
            submitTime: '',
            addPadding: false,
                isHideHeader: true,
        }
    },
    mixins: [mixin],
    components: {
        CarsForm,
    },
    created() {
        const isCheSuPai = new RegExp('chesupai')
        if (isCheSuPai.test(window.navigator.userAgent)) {
            this.isHideHeader = true
        } else {
            this.isHideHeader = false
        }
        this.childAnswerMap = Object.create(null)
        this.getLoginType()
        this.tracking() // 打开未填写埋点
    },
    mounted() {
        if (this.$route.query.type === 'approve') {
            setMessenger('approvalpagename');
            let _this = this;
            window.doValidateAsync = function(cb,operateType) {
                let message = '';
                cb && cb({message: message})
            }
            window.doAppResultAsync = function(cb,operateType){
                _this.$refs.dcDynamicForm.$refs.demoDynamicForm.$children[0].validate().then(res => {
                    _this.$refs.dcDynamicForm.$refs.demoDynamicForm.onSubmit()
                    _this.$nextTick(() => {
                        setTimeout(() => {
                            cb && cb({ message: '' })
                        }, 1200)
                    })
                }).catch(error => {
                    cb && cb({ message: '请填写必填项' })
                })
            }
        }
    },
    computed: {
        isInIframe() {
            const isInIframe = window.self !== window.top;
            if (isInIframe) {
                return true
            } else {
                return false
            }
        },
        pageId() {
            return this.$route.params.pageId
        },
        configData() {
            /**
             * hide: [{hideTopicIndex: 需要隐藏的题目的索引，value: 值为当前题的指定选项值或任何值}]
             */
            this.topicsList.forEach((item, index) => {
                const { skipValue, skipTarget } = item.skipJson || {}
                if (!skipValue) return
                if (skipValue === '0') {
                    // 无条件
                    if (skipTarget) {
                        const newSkipTo = this.topicsList.findIndex(item => item.topicCode === skipTarget)
                        const targetIndex = skipTarget === 'end' ? this.topicsList.length : newSkipTo // 目标题索引
                        for(let i=index+1; i<targetIndex; i++) {
                            const hide = this.topicsList[i].hide || []
                            const obj = Object.assign({}, this.topicsList[i], {hide:[{hideTopicIndex: index, skipValue: '0'},...hide]})
                            this.topicsList.splice(i, 1, obj)
                        }
                    }
                    return
                }
                if (skipValue === '1') {
                    // 按选项
                    item.selectItem.forEach((option) => {
                        let { skipTarget } = option
                        if (skipTarget) {
                            const newSkipTo = this.topicsList.findIndex(item => item.topicCode === skipTarget)
                            const targetIndex = skipTarget === 'end' ? this.topicsList.length : newSkipTo // 目标题
                            for(let i=index+1; i<targetIndex; i++) {
                                const hide = this.topicsList[i].hide || []
                                const obj = Object.assign({}, this.topicsList[i], {hide:[{hideTopicIndex: index, value: option.itemValue, skipValue: '1'},...hide]})
                                this.topicsList.splice(i, 1, obj)
                            }
                        }
                    })
                }
            })
            let time = 0
            let newTopicsList = this.topicsList.map((item, index) => {
                let newIndex = 0
                if (item.topicType == 'paragraph') {
                    time += 1
                }
                newIndex = index - time
                return { ...item, newIndex: newIndex }
            })
            let topicIndex = null
            const groupData = newTopicsList.map((item, index) => {
                const name = item.topicType == 'paragraph' ? '' : (`${item.newIndex + 1}.${item.topicName}`)
                const showJson = item.showJson ? JSON.parse(item.showJson) : null
                let topic = null
                showJson && showJson.list && showJson.list.forEach((obj, objIndex) => {
                    topicIndex = this.topicsList.findIndex(topic => topic.topicCode === obj.id)
                    topic = this.topicsList.find(topic => topic.topicCode === obj.id)
                    if (/^(radio|checkbox)$/.test(topic.topicType)) {
                        obj.conditions.forEach((condition, i) => {
                            topic.selectItem[condition] ? null : obj.conditions.splice(i, 1, '')
                        })
                        obj.conditions = obj.conditions.filter(item => item)
                        if (!obj.conditions.length) {
                            showJson.list.splice(objIndex, 1, '')
                            return
                        }
                    }
                    obj.showIndex = topicIndex > -1 ? topicIndex : null
                })
                showJson && showJson.list ? showJson.list = showJson.list.filter(item => item) : null
                let data = {
                    code: item.topicId,
                    label: name,
                    type: item.topicType == 'paragraph' ? 'textarea' : (item.topicType === 'textarea' && item.inputSize === '1' ? 'text' : item.topicType),
                    placeholder: '',
                    rules: [{ required: item.required, message: `请填写${item.topicName}` }],
                    hide: item.hide,
                    showJson: showJson,
                }
                if (/^(radio|checkbox|matrix-rate)$/.test(item.topicType)) {
                    // 处理 其他输入项
                    let option_list = item.selectItem && item.selectItem.map((cur) => {
                        const parsedChildrenData = this.parseChildrenData(cur.childrenData)
                        const childrenData = parsedChildrenData || (cur.subOption || cur.SubOption ? {
                            subOption: cur.subOption || cur.SubOption || [],
                            subOptionLeastChoose: cur.subOptionLeastChoose || cur.SubOptionLeastChoose || '不限制',
                            subOptionMostChoose: cur.subOptionMostChoose || cur.SubOptionMostChoose || '不限制',
                            enableRemark: cur.enableRemark || '0',
                            mustFillRemark: cur.mustFillRemark || '0',
                            remarkPlaceHolder: cur.remarkPlaceHolder || '',
                        } : null)
                        const data = {
                            label: cur.itemKey,
                            value: cur.itemValue,
                            skipTarget: cur.skipTarget,
                            skipTargetName: cur.skipTargetName,
                            childrenData,
                        }
                        let optionImg = {}
                        let isRadioOrCheckbox = /^(radio|checkbox)$/.test(item.topicType)
                        if (isRadioOrCheckbox) {
                            optionImg.thumbViewUrl = cur.thumbViewUrl
                            optionImg.itemUrl = cur.itemUrl
                        }
                        if (cur.itemIndex == '10000') {
                            data.slot = {
                                code: `otherValue${index}`,
                                component: 'me-field',
                                // label: '输入框',
                                type: 'text',
                                placeholder: '请输入',
                                rules: [{ required: true, message: `请填写${cur.itemKey}` }],
                                props: {
                                    readonly: false,
                                    maxLength: 50,
                                },
                            }
                        }
                        return isRadioOrCheckbox ? {...data, ...optionImg} : data

                    })
                    data.option_list = option_list
                    if (item.topicType === 'checkbox') {
                        data.listeners = Object.assign({}, data.listeners || {}, {
                            childOptionsChange: (payload) => this.handleChildOptionsChange(item, payload),
                            childRemarkChange: (payload) => this.handleChildRemarkChange(item, payload),
                        })
                    }

                    data.props = {
                        max: item.mostChoose,
                        min: item.leastChoose, // 这样不能生效
                        shape: item.topicType == 'radio' ? 'round' : '',
                    }

                    let rightText
                    if (item.leastChoose !== '不限制' && item.mostChoose !== '不限制') {
                        rightText = item.leastChoose === item.mostChoose ? `【请选择${item.leastChoose}项】` : `【请选择${item.leastChoose}-${item.mostChoose}项】`
                    } else if (item.leastChoose !== '不限制') {
                        rightText = `【至少选择${item.leastChoose}项】`
                    } else if (item.mostChoose !== '不限制') {
                        rightText = `【至多选择${item.mostChoose}项】`
                    } else if (item.required === 'true' || item.required === true) {
                        rightText = `请选择${item.topicName}`
                    }
                    if (item.topicType == 'radio') {
                        data.itemProps = {
                            rightIcon: {
                                component: 'me-tag',
                                text: '单选',
                                tips: '',
                                props: {
                                    type: 'success',
                                    plain: true,
                                    size: 'medium',
                                },
                            },
                        }
                    } else if (item.topicType == 'checkbox') {
                        // 处理复选框的最少选
                        data.rules = [
                            // { required: item.required, message: '请检查必选项' },
                            {
                                required: !(item.required === 'false' || item.required === false),
                                message: rightText,
                                validator: (val, rule) => {
                                // 非必填且未勾选 return true
                                    if (!(item.required === 'true' || item.required === true) && val.length === 0) {
                                        return true
                                    }
                                    if (val.length < item.leastChoose && val.length > 0) {
                                        return false
                                    }
                                    // 校验子选项和备注
                                    const validationMessage = this.validateCheckboxChildren(item, val)
                                    if (validationMessage) {
                                        // 设置错误消息
                                        rule.message = validationMessage
                                        return false
                                    }
                                    return true

                                },
                            },
                        ]
                        const itemProps = {
                            rightIcon: {
                                component: 'me-tag',
                                text: '多选',
                                tips: item.leastChoose !== '不限制' || item.mostChoose !== '不限制' ? rightText : '',
                                props: {
                                    type: 'success',
                                    plain: true,
                                    size: 'medium',
                                },
                            },
                        }
                        if (item.labelStyle === '1') {
                            itemProps.class = 'label-style-checkbox'
                        }
                        data.itemProps = itemProps
                    }
                    if (item.topicType === 'checkbox' && item.labelStyle === '1') {
                        data.props = {
                            ...data.props,
                            shape: '',
                        }
                    }
                    if(item.topicType == 'matrix-rate') {
                        data.props.componentType = 'car-matrix-rate'
                        data.props.count = item.score
                        data.rules = [
                            {
                                required: !(item.required === 'false' || item.required === false),
                                message: rightText,
                                validator: (val, rule) => {
                                     if (!item.topicId) {
                                        return;
                                    }
                                    // 获取当前工作项对应的值
                                    const itemVal = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template.itemsMap[item.topicId].getValue()
                                    const map = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template.itemsMap[item.topicId]
                                    const itemLength = map.props.options.length
                                    if (!map.rules[0].required) {
                                        return true
                                    }
                                    if (!itemVal) {
                                        return false
                                    }
                                    if (!(Array.isArray(itemVal) && itemVal.length === itemLength && itemVal.every(item => item))) {
                                        return false
                                    }
                                    return true
                                },
                            },
                        ]
                    }
                }
                if (item.topicType == 'paragraph') {
                    data.props = {
                        readonly: true,
                        autosize: true,
                    }
                    data.value = item.commonNote
                    data.rules = [{ required: false }]
                }
                if (item.topicType == 'textarea' && item.inputSize) {
                    if (item.inputSize === '1') {
                        data.type = 'text'
                        data.props = {
                            maxLength: 300,
                        }
                    } else {
                        data.props = {
                            rows: parseInt(item.inputSize || 3),
                            maxLength: item.inputSize === '5' ? 20000 : 300,
                        }
                    }
                }
                if (item.topicType == 'rate') {
                    data.props = {
                        count: item.score
                    }
                }
                if (/^(rate|nps)$/.test(item.topicType)) {
                    data.labelJson = item.labelJson
                    // 标签必填及数量校验：在问题下方显示（与 checkbox 一致），当前分值无配置标签时跳过校验
                    const ext = (() => {
                        try {
                            return item.extJson ? (typeof item.extJson === 'string' ? JSON.parse(item.extJson) : (item.extJson || {})) : {}
                        } catch (e) { return {} }
                    })()
                    const { labelRequired, labelValid } = ext
                    if (item.labelJson && labelRequired) {
                        const baseRules = data.rules || []
                        data.rules = [
                            ...baseRules,
                            {
                                required: true,
                                message: `请选择${item.topicName}的标签`,
                                validator: (val, rule) => {
                                    const dc = this.$refs.dcDynamicForm
                                    const demo = dc && dc.$refs && dc.$refs.demoDynamicForm
                                    const template = demo && demo.template
                                    const itemsMap = template && template.itemsMap
                                    const templateItem = itemsMap != null ? itemsMap[item.topicId] : undefined
                                    const rawVal = templateItem != null ? templateItem.value : undefined
                                    const compoundVal = (rawVal != null ? rawVal : val)
                                    const tValue = compoundVal && typeof compoundVal === 'object' ? compoundVal : null
                                    const value = tValue != null ? tValue.value : undefined
                                    const label = tValue != null ? tValue.label : undefined
                                    if (value == null) return true
                                    const scoreKey = String(value)
                                    const parsedLabelJson = (() => {
                                        try {
                                            return item.labelJson ? (typeof item.labelJson === 'string' ? JSON.parse(item.labelJson) : (item.labelJson || {})) : {}
                                        } catch (e) { return {} }
                                    })()
                                    const scoreLabels = parsedLabelJson[scoreKey]
                                    const hasLabelsConfigured = scoreLabels && (typeof scoreLabels === 'string' ? scoreLabels.split('\n').filter(s => s && s.trim()) : []).length > 0
                                    if (!hasLabelsConfigured) return true
                                    const labelArr = item.topicType === 'rate' ? (label && label[value - 1]) : (label && label[value])
                                    const labelCount = Array.isArray(labelArr) ? labelArr.length : 0
                                    if (labelCount === 0) {
                                        rule.message = `请选择${item.topicName}的标签`
                                        return false
                                    }
                                    const validItem = (Array.isArray(labelValid) ? labelValid : []).find(v => String(v.score) === scoreKey)
                                    const minCount = (validItem != null && validItem.minCount != null) ? validItem.minCount : 1
                                    const maxCount = (validItem != null && validItem.maxCount != null) ? validItem.maxCount : 20
                                    if (labelCount < minCount || labelCount > maxCount) {
                                        rule.message = `${item.topicName}请选择${minCount}-${maxCount}个标签，当前已选${labelCount}个`
                                        return false
                                    }
                                    return true
                                },
                            },
                        ]
                    }
                }
                return data
            })

            return {
                form: {
                    button: this.$route.query.type === 'approve' ? '' : { disabled: false, text: '提交' },
                    groupData: groupData,
                    props: { showError: true },
                },
                api: {
                    request: {
                        submit: {
                            url: `${this.BASEURL}/questionpage/runtime/save`,
                            method: 'post',
                        },
                    },
                },
            }
        },
    },
    methods: {
        parseChildrenData(data) {
            if (!data) return null
            if (typeof data === 'object') return data
            if (typeof data === 'string') {
                try {
                    return JSON.parse(data)
                } catch (error) {
                    console.warn('parse childrenData error', error)
                    return null
                }
            }
            return null
        },
        ensureChildAnswerEntry(topicId, parentKey) {
            if (!this.childAnswerMap) {
                this.childAnswerMap = Object.create(null)
            }
            const topicKey = String(topicId)
            if (!this.childAnswerMap[topicKey]) {
                this.childAnswerMap[topicKey] = Object.create(null)
            }
            const parent = String(parentKey)
            if (!this.childAnswerMap[topicKey][parent]) {
                this.childAnswerMap[topicKey][parent] = {
                    subSelections: [],
                    remark: '',
                }
            }
            return this.childAnswerMap[topicKey][parent]
        },
        getChildAnswerEntry(topicId, parentKey) {
            if (!this.childAnswerMap) return null
            const topicKey = String(topicId)
            const parent = String(parentKey)
            const topicMap = this.childAnswerMap[topicKey]
            if (!topicMap) return null
            return topicMap[parent] || null
        },
        getTemplateChildEntry(topicId, parentKey) {
            try {
                const formRef = this.$refs.dcDynamicForm && this.$refs.dcDynamicForm.$refs && this.$refs.dcDynamicForm.$refs.demoDynamicForm
                if (!formRef || !formRef.template || !formRef.template.itemsMap) return null
                const templateItem = formRef.template.itemsMap[topicId]
                if (!templateItem) return null

                const parentKeyStr = String(parentKey)

                // 优先从 CheckBoxGroup 组件实例获取最新数据（这是最可靠的，因为它是实时的）
                // 需要递归查找，因为组件可能嵌套在其他组件中
                const findCheckboxGroup = (component) => {
                    if (!component) return null
                    if (component.$options && component.$options.name === 'CarCheckboxGroup') {
                        return component
                    }
                    if (component.$children && component.$children.length) {
                        for (const child of component.$children) {
                            const found = findCheckboxGroup(child)
                            if (found) return found
                        }
                    }
                    return null
                }

                const checkboxGroup = templateItem.component ? findCheckboxGroup(templateItem.component) : null
                if (checkboxGroup) {
                    // 优先从 childExtraMap 获取（这是通过 emitChildState 更新的，总是最新的）
                    if (checkboxGroup.childExtraMap && checkboxGroup.childExtraMap[parentKeyStr]) {
                        const extraEntry = checkboxGroup.childExtraMap[parentKeyStr]
                        return {
                            subSelections: Array.isArray(extraEntry.subSelections)
                                ? extraEntry.subSelections.map(val => String(val))
                                : [],
                            remark: extraEntry.remark ? String(extraEntry.remark) : '',
                        }
                    }

                    // 如果 childExtraMap 中没有，尝试从 childSelections 和 childRemarks 获取
                    // 从 childSelections 获取子选项（v-model 绑定的实时状态）
                    const subSelections = checkboxGroup.childSelections && checkboxGroup.childSelections[parentKeyStr]
                        ? Array.isArray(checkboxGroup.childSelections[parentKeyStr])
                            ? checkboxGroup.childSelections[parentKeyStr].map(val => String(val))
                            : []
                        : []

                    // 从 childRemarks 获取备注（v-model 绑定的实时状态）
                    // 注意：key 可能是字符串或数字
                    let remark = ''
                    if (checkboxGroup.childRemarks) {
                        // 尝试多种 key 格式
                        remark = checkboxGroup.childRemarks[parentKeyStr] ||
                                 checkboxGroup.childRemarks[Number(parentKeyStr)] ||
                                 checkboxGroup.childRemarks[parentKey] || ''
                        remark = remark ? String(remark) : ''
                    }

                    // 如果 childRemarks 中没有值，尝试直接从 me-field 组件实例获取（最可靠的方法）
                    if (!remark) {
                        // 递归查找 me-field 组件实例
                        const findMeField = (component, targetKey) => {
                            if (!component) return null
                            // 检查是否是 me-field 组件
                            if (component.$options && component.$options.name === 'MeField') {
                                // 检查这个 me-field 是否属于目标父选项
                                // 通过检查父组件的 key 或者通过其他方式识别
                                return component
                            }
                            if (component.$children && component.$children.length) {
                                for (const child of component.$children) {
                                    const found = findMeField(child, targetKey)
                                    if (found) return found
                                }
                            }
                            return null
                        }
                        // 查找对应的 me-field 组件实例
                        const meField = findMeField(checkboxGroup.$parent, parentKeyStr)
                        if (meField && meField.value !== undefined) {
                            remark = String(meField.value || '')
                        }
                    }

                    // 组件实例存在，即使数据为空（用户清空了），也应该返回空值，而不是 null
                    // 这样可以确保 validator 能获取到最新的空值状态
                    return {
                        subSelections,
                        remark,
                    }
                }

                // 如果组件实例不存在，尝试从 item.childExtraMap 获取（作为后备）
                const extras = templateItem.item && templateItem.item.childExtraMap ? templateItem.item.childExtraMap : templateItem.childExtraMap || null
                if (extras && extras[parentKeyStr]) {
                    const entry = extras[parentKeyStr]
                    return {
                        subSelections: Array.isArray(entry.subSelections) ? entry.subSelections.map(val => String(val)) : [],
                        remark: entry.remark ? String(entry.remark) : '',
                    }
                }

                // 组件实例不存在，返回 null
                return null
            } catch (error) {
                console.warn('getTemplateChildEntry error:', error)
                return null
            }
        },
        getChildAnswerRecord(topic, parentValue) {
            // 在 validator 执行时，总是优先从组件实例获取最新数据（这是最可靠的，因为它是实时的）
            // getTemplateChildEntry 在组件实例存在时会返回数据（包括空数据），只有在组件实例不存在时才返回 null
            const templateEntry = this.getTemplateChildEntry(topic.topicId, parentValue)

            // 如果组件实例中有数据（包括空数据），优先使用并同步到 childAnswerMap
            if (templateEntry !== null) {
                // 将获取到的数据同步到 childAnswerMap，以便后续使用
                const entry = this.ensureChildAnswerEntry(topic.topicId, parentValue)
                entry.subSelections = templateEntry.subSelections || []
                entry.remark = templateEntry.remark || ''
                return entry
            }

            // 如果组件实例不存在（返回 null），使用 childAnswerMap 中的数据作为后备
            const directEntry = this.getChildAnswerEntry(topic.topicId, parentValue)
            if (directEntry) {
                return directEntry
            }

            // 如果都没有，返回一个空对象，这样校验逻辑可以正确检查必填项
            return {
                subSelections: [],
                remark: '',
            }
        },
        handleChildOptionsChange(topic, payload) {
            const entry = this.ensureChildAnswerEntry(topic.topicId, payload.parentValue)
            const values = Array.isArray(payload.values) ? payload.values.map(val => String(val)) : []
            entry.subSelections = values
        },
        handleChildRemarkChange(topic, payload) {
            const entry = this.ensureChildAnswerEntry(topic.topicId, payload.parentValue)
            entry.remark = payload && payload.value ? String(payload.value) : ''
        },
        normalizeRequirement(value) {
            if (value === undefined || value === null) return null
            if (typeof value === 'number') return isNaN(value) ? null : value
            const str = String(value)
            if (!str || str === '不限制') return null
            const match = str.match(/\d+/)
            if (match && match.length) {
                const num = parseInt(match[0], 10)
                return isNaN(num) ? null : num
            }
            return null
        },
        normalizeSelectedValues(value) {
            if (Array.isArray(value)) {
                return value.map(v => String(v)).sort((a, b) => Number(a) - Number(b))
            }
            if (value === undefined || value === null || value === '') return []
            return [String(value)]
        },
        getParentOptionByValue(topic, parentValue) {
            const val = String(parentValue)
            if (!Array.isArray(topic.selectItem)) return null
            return topic.selectItem.find(opt => String(opt.itemValue) === val)
        },
        validateCheckboxChildren(topic, selectedValues) {
            if (!Array.isArray(selectedValues) || !selectedValues.length) return null
            for (const parentValue of selectedValues) {
                const option = this.getParentOptionByValue(topic, parentValue)
                if (!option) continue
                const childrenData = this.parseChildrenData(option.childrenData) || option.childrenData
                if (!childrenData) continue

                const entry = this.getChildAnswerRecord(topic, parentValue) || {}

                // 1. 检查备注必填
                if (childrenData.enableRemark === '1' && childrenData.mustFillRemark === '1') {
                    const remarkText = (entry.remark || '').trim()
                    if (!remarkText) {
                        const label = option.itemKey || `选项${Number(parentValue) + 1}`
                        return `请填写「${topic.topicName || ''}${label ? ' - ' + label : ''}」的备注信息`
                    }
                }

                // 2. 检查子选项的最少/最多选择限制（只有当存在子选项时才检查）
                const hasSubOptions = Array.isArray(childrenData.subOption) && childrenData.subOption.length > 0
                if (hasSubOptions) {
                    const selectedSubs = Array.isArray(entry.subSelections) ? entry.subSelections : []
                    const min = this.normalizeRequirement(childrenData.subOptionLeastChoose)
                    const max = this.normalizeRequirement(childrenData.subOptionMostChoose)

                    if (min !== null && selectedSubs.length < min) {
                        const label = option.itemKey || `选项${Number(parentValue) + 1}`
                        return `「${topic.topicName || ''}${label ? ' - ' + label : ''}」至少选择 ${min} 个子选项`
                    }
                    if (max !== null && selectedSubs.length > max) {
                        const label = option.itemKey || `选项${Number(parentValue) + 1}`
                        return `「${topic.topicName || ''}${label ? ' - ' + label : ''}」最多选择 ${max} 个子选项`
                    }
                }
            }
            return null
        },
        buildCheckboxTopicValue(topic, selectedValues) {
            if (!Array.isArray(selectedValues) || !selectedValues.length) return ''
            const segments = []
            selectedValues.forEach((value) => {
                const parentKey = String(value)
                let segment = parentKey
                const entry = this.getChildAnswerRecord(topic, parentKey)
                if (entry && Array.isArray(entry.subSelections) && entry.subSelections.length) {
                    const subs = entry.subSelections
                        .map((val) => String(val))
                        .filter((val) => val !== '')
                        .sort((a, b) => Number(a) - Number(b))
                    if (subs.length) {
                        segment += `〖${subs.join('┋')}〗`
                    }
                }
                if (entry && entry.remark && entry.remark.trim()) {
                    segment += `〖〗${entry.remark.trim()}`
                }
                segments.push(segment)
            })
            return segments.join('┋')
        },
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            isAndroid ? this.addPadding = true : null
        },
        removeEventListenerForInput() {
            console.log('removeEventListenerForInput')
            const isAndroid = /android/i.test(window.navigator.userAgent)
            isAndroid ? this.addPadding = false : null
        },
        getSource() {
            const ua = navigator.userAgent
            const types_desc = {
                wixi: '微信',
                guagua: '呱呱',
                ios: 'IOS终端',
                android: '安卓终端',
                wekit: 'PC浏览器',
            }
            const types = {
                wixi: /MicroMessenger/.test(ua),
                guagua: /Guazi\/guagua/.test(ua),
                ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua),
                android: /Android/.test(ua),
                wekit: !/\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua) && !/Android/.test(ua),
            }
            let sourceType = ''
            Object.entries(types).forEach(([key, value]) => {
                if (value) {
                    sourceType += types_desc[key]
                }
            })
            return sourceType
        },
        tracking(submitTime = '', trackingInfo = {
                    answerTopic: '',
                    answerTime: '',
                    sourceType: this.getSource(),
                }, answerStatus = 'NotAnswer') {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
                openTime: this.formatDate(this.openTime),
                submitTime,
                answerStatus,
                trackingInfo,
            }
            Questionnaire.tracking(data)
        },
        formatDate(date, yyMMdd) {
            date = new Date(date)
            const month = this.padEnd(date.getMonth() + 1)
            const day = this.padEnd(date.getDate())
            const hours = this.padEnd(date.getHours())
            const minutes = this.padEnd(date.getMinutes())
            const seconds = this.padEnd(date.getSeconds())
            let val = `${date.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`
            return yyMMdd ? `${date.getFullYear()}${month}${day}` : val
        },
        padEnd(val) {
            return val < 10 ? '0' + val : val
        },
        getOutGuaGuapage(url='' , env='prod') {
            let pageEnv = {
                'dev' : 'http://devplt-culture.guazi-cloud.com/callApp.html',
                'test': 'https://testplt-culture.guazi-cloud.com/callApp.html',
                'uat': 'https://uatplt-culture.guazi-cloud.com/callApp.html',
                'online': 'https://plt-culture.guazi.com/callApp.html',
            }
            return `${pageEnv[env]}?returnUrl=${encodeURIComponent(decodeURIComponent(url))}`
        },
        getLoginType() {
            const data = {
                type: 'question',
                tid: this.tid,
                pageId: this.pageId,
            }
            Questionnaire.getLoginType(data).then((res) => {
                let { data: { data: { loginType, answerType, shareUrl, qrCodeUrl } } } = res
                this.isAnonymous = loginType === 'Anonymous'
                this.shareUrl = shareUrl
                this.qrCodeUrl = qrCodeUrl
                const { guaguaApp } = browser
                this.isGuaGua = guaguaApp
                // 只能在呱呱中打开
                if (answerType && !guaguaApp) {
                    removeClass2('body', 'loading')
                    if (this.$route.query.type === 'approve') {
                        this.showConfirmBtn = true
                        this.msgTips = '抱歉，该问卷只允许在呱呱APP端作答，请您使用呱呱APP端打开'
                        this.isRunning = false
                        return
                    }
                    const href = this.getOutGuaGuapage(shareUrl, ENV)
                    window.location.href = href
                    this.isRunning = false
                    return
                }
                this.getRuntimeIndex()
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        submitError(e) {
            setTimeout(() => {
                document.documentElement.scrollTop = getScrollTop(document.getElementsByClassName('me-field__error-message')[0]) - 50
            }, 10)
        },
        // 匿名时校验次数 
        overAnswerTimes() {
            let flag = false
            let { limitType } = this.question
            let pageId = this.pageId
            let [, day, times] = /([0-9]*)_([0-9])/.exec(limitType) || []
            let storage_times = getStorage('anonymous_times')
            let hasStoragePageId = storage_times && storage_times[pageId]
            let endRange = this.getComputedDate(new Date())
            let startRange = 0
            let answerTimes = 0
            let answered = hasStoragePageId ? storage_times[pageId] : []
            if (/Client┇Limit_Day/.test(limitType) && hasStoragePageId) {
                switch (day) {
                    case '1':
                        answered.forEach((item) => {
                            let [key, val] = Object.entries(item)[0]
                            key == endRange ? answerTimes += val : null
                        })
                        break
                    case '7':
                    case '30':
                        startRange = this.getComputedDate(new Date(), day - 1)
                        answered.forEach((item) => {
                            let [key, val] = Object.entries(item)[0]
                            startRange <= key && key <= endRange ? answerTimes += val : null
                        })
                        break
                }

            } else if (/Client┇Limit_/.test(limitType) && hasStoragePageId) {
               switch (times) {
                    case '1':
                    case '2':
                    case '3':
                        answered.forEach((item) => {
                            let [key, val] = Object.entries(item)[0]
                            answerTimes += val
                        })
                        break
                }
            }
            answerTimes >= times ? flag = true : null
            return flag
        },
        clearAnonymousTimes() {
            let storage_times = getStorage('anonymous_times')
            let clearValue = this.getComputedDate(new Date(), 30)
            let deletePageIds = []
            if (storage_times) {
                Object.entries(storage_times).forEach(([pageId, values]) => {
                    values.forEach((item, index) => {
                        clearValue >= Object.keys(item)[0] ? values.splice(index, 1, 0) : null
                    })
                    values = values.filter(item => item)
                    !values.length ? deletePageIds.push(pageId) : null
                })
                deletePageIds.forEach((pageId) => {
                    delete storage_times[pageId]
                })
                setStorage('anonymous_times', storage_times)
            }
        },
        getRuntimeIndex() {
            addClass2('body', 'loading')
            // question：调查问卷；form：审批表单；
            const data = {
                type: 'question',
                tid: this.tid,
                pageId: this.pageId,
            }
            const interfaceName = this.isAnonymous ? 'getRuntimeAnoInit' : 'getRuntimeInit'
            Questionnaire[interfaceName](data).then((res) => {
                removeClass2('body', 'loading')
                this.showConfirmBtn = true
                if (res.data.code == 'S00000') {
                    this.question = res.data.data
                    this.childAnswerMap = Object.create(null)
                    if (this.overAnswerTimes()) {
                        this.isRunning = false
                        this.msgTips = '抱歉，您已超过答题次数，不能再次作答'
                        return
                    }
                    this.footer = this.question.footer || 'eim'
                    this.topicsList = this.question.topicsList
                    this.clearAnonymousTimes() // 清理30天以外的数据
                } else {
                    this.isRunning = false
                    this.msgTips = res.data.message || '已经不能作答'
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                this.showConfirmBtn = true
                this.question.pageName = ''
                // Toast.fail(error.response.data.message)
                this.isRunning = false
                this.msgTips = error.response.data.message
            })
        },
        async submitSuccess(res) {
            addClass2('body', 'loading')
            const dynamicFormTemplateMap = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template.itemsMap
            // 批量组件 单选/多选
            for (let index = 0; index < this.topicsList.length; index++) {
                const item = this.topicsList[index]
                if (item.topicType == 'radio' || item.topicType == 'checkbox') {
                    // 多选的 ┋ 分割

                    item.selectItem.map((kk) => {
                        if (kk.itemIndex == '10000') {
                            item.otherValue = res[`otherValue${index}`]
                        }
                    })
                    if (item.topicType == 'checkbox') {
                        const selectedValues = this.normalizeSelectedValues(res[item.topicId])
                        const validationMessage = this.validateCheckboxChildren(item, selectedValues)
                        if (validationMessage) {
                            removeClass2('body', 'loading')
                            Toast.fail(validationMessage)
                            return
                        }
                        item.topicValue = this.buildCheckboxTopicValue(item, selectedValues)
                    } else {

                        item.topicValue = res[item.topicId]
                    }


                } else if (item.topicType === 'matrix-rate') {
                    let sortResult = []
                    let singValue = ''
                    item.selectItem.map((kk, i) => {
                        singValue = res[item.topicId] && res[item.topicId][i] || ''
                        sortResult.push(singValue)
                    })
                    item.topicValue = sortResult.join('┇')
                } else if(/^(rate|nps)$/.test(item.topicType)) {
                    const compoundValue = dynamicFormTemplateMap[item.topicId]
                    let { value:tValue, labelJson } = compoundValue || {}
                    let { value, label, message } = tValue || {}
                    // 标签必填及数量校验（表单 rules 已做内联校验，此处仅作兜底；当前分值无配置标签时跳过）
                    let ext = {}
                    if (item.extJson) {
                        try {
                            ext = typeof item.extJson === 'string' ? JSON.parse(item.extJson) : (item.extJson || {})
                        } catch (e) { ext = {} }
                    }
                    const { labelRequired, labelValid } = ext
                    if (item.labelJson && labelRequired && value != null) {
                        const scoreKey = String(value)
                        const parsedLabelJson = (() => {
                            try {
                                return typeof item.labelJson === 'string' ? JSON.parse(item.labelJson) : (item.labelJson || {})
                            } catch (e) { return {} }
                        })()
                        const scoreLabels = parsedLabelJson[scoreKey]
                        const hasLabelsConfigured = scoreLabels && (typeof scoreLabels === 'string' ? scoreLabels.split('\n').filter(s => s && s.trim()) : []).length > 0
                        if (hasLabelsConfigured) {
                            const labelArr = item.topicType === 'rate' ? (label && label[value - 1]) : (label && label[value])
                            const labelCount = Array.isArray(labelArr) ? labelArr.length : 0
                            if (labelCount === 0) {
                                removeClass2('body', 'loading')
                                Toast.fail(`请选择${item.topicName}的标签`)
                                return
                            }
                            const validItem = (Array.isArray(labelValid) ? labelValid : []).find(v => String(v.score) === scoreKey)
                            const minCount = (validItem != null && validItem.minCount != null) ? validItem.minCount : 1
                            const maxCount = (validItem != null && validItem.maxCount != null) ? validItem.maxCount : 20
                            if (labelCount < minCount || labelCount > maxCount) {
                                removeClass2('body', 'loading')
                                Toast.fail(`${item.topicName}请选择${minCount}-${maxCount}个标签，当前已选${labelCount}个`)
                                return
                            }
                        }
                    }
                    // 2〖标签1┋标签2┋标签3〗
                    item.topicValue = value
                    if(label && Object.keys(label).length) {
                        label = item.topicType === 'rate' ? label[value-1] : label[value]
                        let labelStr = []
                        label = label.sort((a,b) => {return a.index - b.index})
                        label.forEach((item) => {
                            labelStr.push(item.item)
                        })
                        item.topicValue += `〖${labelStr.join('┇')}〗`
                    } else if(labelJson) {
                        item.topicValue += '〖〗'
                    }
                    item.otherValue = message || ''
                } else {
                    item.topicValue = res[item.topicId]
                }
            }
            // 返回的是加密后的id 这里需要数据库id
            this.question.pageId = this.pageId
            /**
             * hideTopicIndex：目标题索引
             * skipValue：0无条件跳题 1按选项跳题
             * value：目标题值
             * 思路：
             * 当前题是否隐藏，看hide每一项是否有符合的
             * hide为数组，一真为真
             */
            this.configData.form.groupData.forEach((item, index) => {
                if (item.hide) {
                    for (let hide of item.hide) {
                        let { hideTopicIndex, skipValue, value } = hide
                        let topicId = this.topicsList[hideTopicIndex].topicId
                        let topicValue = res[topicId]
                        if (skipValue === '0') {
                            let flag = Array.isArray(topicValue) ? topicValue.length : topicValue
                            if (flag) {
                                this.topicsList[index].skipFlag = !!flag
                                return
                            }
                        }
                        if (skipValue === '1') {
                            if (topicValue == value) {
                                this.topicsList[index].skipFlag = topicValue == value
                                return
                            }
                        }
                    }
                }
            })
            // 有显示条件控制时，没有答的题目加skipFlag标签
            const groupData = this.$refs.dcDynamicForm.$refs.demoDynamicForm.template.items
            groupData.forEach((data, index) => {
                if (data.showJson && data.showJson.list && data.showJson.list.length) {
                    const { list, relate } = data.showJson
                    if (list.length) {
                        this.topicsList[index].skipFlag = relate ? !list.every(value => value.show) : !list.some(value => value.show)
                    }
                    return
                }
                this.topicsList[index].skipFlag = false
            })
            const topicList_bak = JSON.parse(JSON.stringify(this.topicsList))
            this.topicsList.forEach((item) => {
                if (item.hide) {
                    delete item.hide
                }
            })
            this.submitTime = new Date().getTime()
            const data = {
                type: 'question',
                tid: this.tid,
                'bitEdit': true,
                'createdBy': '',
                'answerTime': Math.floor((this.submitTime - this.openTime) / 1000),
                'sourceType': this.getSource(),
                gzUserId: '',
                'sourceUrl': '',
                'ip': '',
                openTime: this.formatDate(this.openTime),
                submitTime: this.formatDate(this.submitTime),
                ...this.question,
            }
            let { guaguaApp } = browser
                if (guaguaApp) {
                    let info = await userInfoReady()
                    console.log(info, 'info')
                    if (info.code == 0 && info.data.longUserId) {
                        data.gzUserId = info.data.longUserId || ''
                    }
                }
            if (this.$route.query._gzuserid&& this.$route.query._gzuserid != '-1') {
                data.gzUserId = this.$route.query._gzuserid || ''
            }
            const interfaceName = this.isAnonymous ? 'getRuntimeAnoSave' : 'getRuntimeSave'
            console.log(data, 'data')
            Questionnaire[interfaceName](data).then((res) => {
                removeClass2('body', 'loading')
                if (res.data.code == 'S00000') {
                    this.isRunning = false
                    this.msgTips = this.question.endContent || '您已完成本次答卷，感谢您的帮助与支持!'
                    // this.isAnonymous = false
                    // 有效答卷埋点
                    this.answerTring()
                    // 匿名做缓存
                    this.setTimes()
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                // Toast.fail(error.response.data.message)
                this.isRunning = false
                this.msgTips = error.response.data.message
                this.topicsList = topicList_bak
            })
        },
        setTimes() {
            let { limitType } = this.question
            let pageId = this.pageId
            if (/Client┇Limit_/.test(limitType)) {
                let storage_times = getStorage('anonymous_times')
                let currentKey = this.getComputedDate(new Date())
                if (storage_times && storage_times[pageId]) {
                    let answereds = storage_times[pageId]
                    let answered = answereds.find(item => item[currentKey])
                    answered ? answered[currentKey]++ : answereds.push({[currentKey]: 1})
                } else {
                    storage_times = {}
                    storage_times[pageId] = [{ [currentKey]: 1 }]
                }
                setStorage('anonymous_times', storage_times)
            }
        },
        getComputedDate(val, num = 0) {
           return this.formatDate(val.setDate(val.getDate() - num), true) / 1
        },
        answerTring() {
            const trackingInfo = {
                answerTopic: '',
                answerTime: Math.floor((this.submitTime - this.openTime) / 1000),
                sourceType: this.getSource(),
            }
            const answerStatus = 'Valid'
            this.tracking(this.formatDate(this.submitTime), trackingInfo, answerStatus)
        },
        copyUrl() {
            copy(this.shareUrl).then(() => {
                Toast.success({
                    message: '复制成功',
                    position: 'top',
                })
            }).catch((error) => {
                console.log('copy text error', error)
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .addPadding{
        padding-bottom: 400PX!important;
    }
    .wrap{
        position: relative;
        // background: #F2F4F6;
        height: 100%;
        // height: calc(100% - 50px);
        .content{
            padding: 12px;
            padding-bottom: 4.5rem;
            position: relative;
            min-height: calc(100% - .32rem - 4.5rem);
            // overflow-y: scroll;
            // height: calc(100% - 80px);
        }
        .question-tip{
            padding-left: 16px;
            margin-top: 13px;
            color: #F74D4D;
            &:before{
                display: inline-block;
                content: 'i';
                margin-right: 3px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                border-radius: 50%;
                text-align: center;
                color: #fff;
                background: #F74D4D;
            }
        }
        .copyright{
            display: block;
            margin: 38px auto 0;
            width: 4.56rem;
            height: auto;
            position: absolute;
            bottom: 2.66667rem;
            left: 50%;
            transform: translateX(-50%);
        }
        .question-header{
            position: relative;
            .title{
                width: 90%;
            }
        }
        .question-copy-url{
            position: absolute;
            right: 17px;
            top: 17px;
            width: 23px;
            height: 23px;
        }
    }
    ::v-deep .msg-tips{
        background: #F2F4F6;
        position: relative;
        height: 100%;
        .tips-wrap{
            width: 100%;
            position: absolute;
            left: 50%;
            top: 40%;
            font-size: 0.37333rem;
            transform: translate(-50%, -50%);
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            .me-field__control{
                text-align: center;
            }
        }
        .c-bg{
            margin-bottom: 18PX;
            width: 205PX;
            height: 164PX;
            background: url(../images/c-bg.png) no-repeat;
            background-size: contain;
        }
        .c-text{
            display: inline-block;
            width: 7.5rem;
            line-height: 24PX;
            font-size: 14PX;
            color: #333;
        }
        .b-bg{
            position: absolute;
            bottom: 0;
            padding: 18PX;
            width: 100%;
            box-sizing: border-box;
        }
        .b-app{
            max-width: 100%;
        }
        .b-pc{
            display: none;
        }
        .create-ques{
            display: inline-block;
            width: 120PX;
            height: 30PX;
            line-height: 30PX;
            text-align: center;
            background: #06B455;
            color: #fff;
            border-radius: 4PX;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    ::v-deep .comment{
        border-top: 0.01333rem solid #F2F4F6;
        padding: 0.3rem 0 0 0;
        color: #5f6670;
        white-space: break-spaces;
    }
    ::v-deep .dynamic-form-container{
        padding: 0;
        .dynamic-form-fielditem::after{
            border: none;
        }
        .dynamic-form-fielditem{
            border-radius: 6px;
            margin-bottom: 12px;
            overflow: hidden;
            .slot-wrap{
                margin-top: -18px;
            }
            .me-radio-group{
                span .me-cell{
                    margin-top: 12px;
                    padding-bottom: 15px;
                }

            }
            .me-field__control {
                .me-cell__value{
                    .me-field__error-message{
                        position: absolute;
                        top: 31px;
                    }
                }
            }
            /* rate/nps 标签校验错误提示显示在问题下方（与 checkbox 一致） */
            &:has(.car-rate) .me-field__error-message,
            &:has(.nps) .me-field__error-message {
                position: static !important;
                margin-top: 8px;
            }
            /* rate/nps 校验错误时：标签按钮和输入框不继承红色，仅错误提示为红色 */
            &:has(.car-rate) .car-label .label:not(.active),
            &:has(.nps) .car-label .label:not(.active) {
                color: #333 !important;
            }
            &:has(.car-rate) .car-label .label.active,
            &:has(.nps) .car-label .label.active {
                color: #fff !important;
            }
            &:has(.car-rate) .me-field__control,
            &:has(.nps) .me-field__control {
                color: #323233 !important;
                border-color: #dcdfe6 !important;
            }
            &:has(.car-rate) .car-label .message,
            &:has(.nps) .car-label .message {
                border-color: #dcdfe6 !important;
            }
            &:has(.car-rate) .car-label .message input,
            &:has(.car-rate) .car-label .message textarea,
            &:has(.nps) .car-label .message input,
            &:has(.nps) .car-label .message textarea {
                color: #323233 !important;
            }
            &:has(.car-rate) .car-label .message input::placeholder,
            &:has(.car-rate) .car-label .message textarea::placeholder,
            &:has(.nps) .car-label .message input::placeholder,
            &:has(.nps) .car-label .message textarea::placeholder {
                color: #c8c9cc !important;
            }
            &:has(.car-rate) .car-label .message input::-webkit-input-placeholder,
            &:has(.car-rate) .car-label .message textarea::-webkit-input-placeholder,
            &:has(.nps) .car-label .message input::-webkit-input-placeholder,
            &:has(.nps) .car-label .message textarea::-webkit-input-placeholder {
                color: #c8c9cc !important;
            }
            .me-field__label{
                padding: 12px 0;
                margin-bottom: 0;
            }
            .me-cell--required::before{
                top: 25px;
                left: 8px;
            }
            .me-checkbox-group{
                width: 100%;
                span .me-cell{
                    line-height: 48px;
                    padding: 0 12px;
                    margin-top: 16px;
                    padding-bottom:13px ;
                }
                .me-cell__value{
                    .me-field__error-message{
                        position: absolute;
                        top: 20px;
                    }
                }
            }
            .me-radio-group {
                width: 100%;
                .me-radio {
                    width: 100%;
                }
                .me-radio__label{
                    width: 100%;
                }
            }
            .me-radio__label{
                display: flex;
                align-items: center;
                // .me-radio__label,span{
                //     min-width: 30px;
                // }
                > div:first-child {
                    align-items: center !important;
                    width: 100%;
                    justify-content: space-between;
                }
                > div > span:first-child{
                    min-width: 30px;
                    flex: 1;
                    + span {
                        width: 200px;
                    }
                }
                .me-cell{
                    min-height: 24px;
                    line-height: 24px;
                    padding: 0 12px;
                }
            }

            .me-cell{
              min-height: 52px;
              line-height: 24px;
            }
            .me-cell__title{
                font-size: 14px;
                font-weight: bold;
                color:#222;
                // min-height: 52px;
                line-height: 26px;
                padding: 0;
                padding-right: 20px;
                margin: 12px 0 0;
            }

            .me-field__body{
                input,textarea {
                    background: #F6F6F6;
                    line-height: 36px;
                    border-radius: 6px;
                    padding-left: 16px ;
                }
                .me-field__control--custom {
                    //  .me-checkbox__label{
                    //     min-width: 30px;
                    // }
                    .me-checkbox {
                        flex: 1;
                        + span {
                            width: 200px;
                        }
                    }
                    >div {
                        >div {
                            padding: 12px 0;
                            align-items: center!important;
                            justify-content: space-between;
                            width: 100%;
                        }
                    }
                }
            }
            // 处理错误信息显示距离问题
            // .me-field__body + .me-field__error-message{
            //     // margin-top: 10px;
            // }
            .me-cell__value--alone {
                textarea[readonly="readonly"]{
                    padding-left: 0;
                    background: #fff;
                    color: #9298A8;
                    font-size: 14px;
                    margin-bottom: 0;
                    line-height: 24px;
                    height: auto;
                }
            }
            // .me-field--min-height .me-field__control{
            //     min-height: 36px;
            // }
        }
        .dynamic-form-footer{
            .me-button--primary{
                background: #06B455;
            }
        }
        .label-style-checkbox {
            .me-cell__value {
                margin-top: 12px;
            }
            .checkbox-wrap {
                width: auto !important;
                padding: 0 !important;
            }
            .me-checkbox-group {
                display: flex;
                flex-wrap: wrap;
                gap: 12px 12px;
            }
            .me-checkbox {
                background: #F2F4F6;
                border-radius: 4px;
                padding: 8px 16px;
                font-family: PingFangSC, 'PingFang SC', sans-serif;
                font-weight: 400;
                font-size: 14px;
                color: #424B58;
                margin-right: 0;
                border: none;
                display: inline-flex;
                align-items: center;
            }
            .me-checkbox__icon {
                display: none;
            }
            .me-checkbox__label {
                width: auto;
                margin: 0 !important;
            }
            .me-checkbox[aria-checked="true"] {
                background: #05B555;
                color: #FFFFFF;
            }
            .me-checkbox[aria-checked="true"] .me-checkbox__label {
                color: #FFFFFF;
            }
        }
    }
</style>
<style lang="less" scoped>
// @import url(../style/pc.less);
.question-bg, .question-pc-copy-url, .question-qr-code{
    display: none;
}
.question-pc-tip{
    display: none;
}
.question-line,.b-pc{
    border: none;
}
::v-deep .me-checkbox__icon--checked .me-icon, ::v-deep .me-radio__icon--checked .me-icon{
    background-color: #06B455;
    border-color: #06B455;
}
::v-deep .me-cell--clickable:active {
    background-color: #fff;
}
/*单选多选*/
::v-deep .me-radio,
::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__body .me-field__control--custom > div > div{
    margin: 0!important;
    padding: 10px 0 10px 0.2962rem;
    // height: .7407rem!important;
    line-height: .7407rem!important;
    overflow: visible;
}
@media screen and (min-width: 769px) {
    body{
        background: #fff;
    }
    .head-prop{
        display: none;
    }
    #app{
        min-height: 100%;
        background: #f7f7f7;
    }
    .question-bg{
        display: block;
        width: 100%;
        height: 12.5rem;
        position: absolute;
        top: 0;
        left: 0;
        background: url('../images//bg.png') no-repeat;
        background-size: 100% auto;
    }
    .question-header{
        margin-bottom: 0;
        padding: 0;
        position: static!important;
    }
    .wrap{
        margin: 0 auto;
        padding-top: 2.407rem;
        max-width: 16.1111rem;;
        min-height: 100%!important;
        background: #f7f7f7!important;
        box-sizing: border-box;
        position: static!important;
    }
    .wrap .content{
        padding: 1.1851rem .9269rem 4rem!important;
        position: relative;
        min-height: calc(100% - .32rem - 6rem);
    }
    ::v-deep .dynamic-form-footer{
        position: absolute;
        bottom: 2rem;
        left: 0;
        margin-left: 50%;
        transform: translateX(-50%);
    }

    ::v-deep .dynamic-form-container .dynamic-form-fielditem{
        margin: 0!important;
        overflow: visible!important;
    }
    ::v-deep .dynamic-form-container, .wrap .content{
        background: #fff;
    }
    .question-header .title{
        margin: 0 auto 1rem;
        padding-bottom: 0;
        max-width: 8.8888rem;
        font-size: .4444rem;
        text-align: center;
        text-align: center;
        line-height: .6296rem;
        font-size: .4444rem;
        color: #333;
    }
    .question-header .comment{
        // margin-top: .4074rem;
        padding: 0;
        font-size: .2592rem;
        color: #5f6670;
        line-height: .444rem;
        border-top: 0;
        font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-cell__value--alone textarea[readonly=readonly]{
        line-height: .4814rem!important;
        font-size: .2962rem!important;
        color: #9298A8 !important;
        border: none;
        margin-top: .5925rem;
    }
    ::v-deep .me-field__control:disabled{
        -webkit-text-fill-color: #5F6670 !important;
    }
    // 提示
    .question-tip{
        display: none;
    }
    .question-pc-tip{
        display: block;
        margin-top: .2962rem;
        color: #F74D4D;
        font-size: .2592rem;
        &:before{
            content: '';
            display: inline-block;
            width: .2962rem;
            height: .2962rem;
            background: url('../images/warning-circle.png') no-repeat;
            background-size: contain;
            vertical-align: -.0555rem;
        }
    }
    .question-line{
        padding-bottom: .2962rem;
        border-bottom: 1px dashed #F2F4F6;
    }
    .question-qr-code{
        display: block;
        position: absolute;
        top: .44rem;
        left: .44rem;
        width: 1.666rem;
        height: 1.666rem;
    }
    ::v-deep .me-checkbox-group .slot-wrap{
        // display: block!important;
        .me-field{
            // margin-top: 10px;
            // padding: 0;
        }
    }

    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-cell__title{
        margin-bottom: 0!important;
        font-size: .2962rem!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-cell{
        padding-left: 0;
        padding-top: 0;
        background: #fff;
        padding-bottom: 0!important;
    }
    ::v-deep .me-radio__icon{
        font-size: .2962rem!important;
    }
    // 标题
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-cell__title{
        color: #333!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-cell--required::before {
        top: .4rem!important;
        left: -.2rem!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .rightIcon {
        width: auto;
        font-size: .2407rem;
        text-align: center;
        padding: .037rem .111rem;
        color: #06B455;
        font-weight: normal;
    }
    // 选项
    ::v-deep .me-radio__label,
    ::v-deep .me-checkbox__label{
        font-size: .2962rem;
        color: #373b3e;
    }
    ::v-deep .me-checkbox__icon--checked .me-icon,
    ::v-deep .me-checkbox__icon .me-icon{
        border-radius: .0555rem;
        font-size: .2962rem!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-checkbox-group .me-cell__value .me-field__error-message{
        top: 0.82667rem!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .tips{
        margin-top: 0!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-radio__label > div > span:first-child + span,
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__body .me-field__control--custom .me-checkbox + span {
        width: 9rem;
    }
    // 输入框
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__body input,
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__body textarea{
        background: #fff!important;
        line-height: .6rem!important;
        border-radius: .0740rem!important;
        border: 1px solid #dcdfe6;
        font-size: .2592rem;
        padding-left: .1111rem!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__body textarea,
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__body input{
        line-height: .4814rem;
        margin-top: .1851rem;
        margin-left: .2962rem!important;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-radio-group span .me-cell{
        padding-bottom: 0 !important;
        margin-top: 0;
    }
    ::v-deep .dynamic-form-container .dynamic-form-fielditem .me-field__control .me-cell__value .me-field__error-message{
        // line-height: 1;
    }
    /*确定按钮*/
    ::v-deep .dynamic-form-container .form_submit{
        position: relative;
        margin: .5555rem auto;
        padding: 0;
        width: 2.1333rem;
        background: transparent;
    }
    ::v-deep .dynamic-form-container .dynamic-form-footer .me-button--primary{
        width: 2.1333rem;
        height: .6296rem;
        line-height: .5555rem;
        font-size: .2592rem;
    }
    // 错误提示
    .me-field__error-message{
        font-size: .2962rem;
    }
    .wrap .copyright{
        width: 190PX!important;
        bottom: .6rem;
    }
    // 复制连接
    .question-copy-url{
        display: none;
    }
    .question-pc-copy-url{
        display: block;
        position: absolute;
        right: 0.444rem!important;
        top: 0.444rem!important;
        width: auto!important;
        height: auto!important;
        cursor: pointer;
        .copy-img{
            width: .3333rem;
            vertical-align: middle;
        }
        .copy-text{
            color: #06B455;
            vertical-align: middle;
        }
    }
    .b-app{
        display: none;
    }
    .msg-tips{
        height: calc(100% - 60PX)!important;
        background: #fff!important;
        .b-bg{
            padding: 0!important;
        }
        .create-ques{
            display: none!important;
        }
    }
    .b-pc{
        display: block!important;
        background: url(../images/b-pc.png) no-repeat;
        width: 100%;
        height: 82PX;
        background-size: 100% 100%;
    }
    .c-text{
        width: auto!important;
    }
    // ::v-deep .desc{
    //     font-size: 16PX!important;
    // }
}
</style>
